<template>
  <v-container fluid>
    <Keyboard v-model="keyboard" layout="compact" />

    <v-row no-gutters>
      <v-col>
        <v-select
          rounded
          :items="data"
          outlined
          item-text="strNombre"
          item-value="intPOSTipoVenta"
          label="Tipo Venta"
          v-model="localValue.tipo"
        >
        </v-select>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col>
        <v-text-field
          rounded
          :readonly="disabled"
          v-model="localValue.clave"
          label="Clave"
          outlined
          @click="showKeyboard($event)"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- FORMULARIO TELEFONO -->
    <v-row v-if="!disabledView">
    <v-row no-gutters>
      <v-col>
        <v-combobox 
        :readonly="disabledView" 
        item-text="strTelefono" 
        item-value="strTelefono" 
        :items="clientes.data" 
        :search-input.sync="search" 
        placeholder="Buscar..." 
        label="Telefono" 
        outlined 
        rounded 
        :return-object="true"
        dense v-model="localValue.strTelefono" 
        
        @focus="cargarTelefonos()" 
         > 
      </v-combobox>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col>
        <v-text-field
          :readonly="disabledView"
          dense
          rounded
          outlined
          v-model="localValue.strNombre"
          label="Nombre"
        >
        </v-text-field>
      </v-col>
    </v-row>



    <v-row no-gutters class="d-none">
      <v-col>
        <v-text-field
          :readonly="disabledView"
          v-model="localValue.strColonia"
          label="Colonia"
          outlined
          rounded
          dense
        >
        </v-text-field>
       
      </v-col>
    </v-row>

    <v-row no-gutters class="d-none">
      <v-col>
        <v-text-field
          :readonly="disabledView"
          dense
          rounded
          outlined
          v-model="localValue.strEntreCalle"
          label="Entre Calles"
        >
        </v-text-field>
      </v-col>
    </v-row>

    
    <v-row no-gutters class="d-none">
      <v-col>
        <v-text-field
          :readonly="disabledView"
          dense
          outlined
          rounded
          v-model="localValue.strPoblacion"
          label="Municipio"
        >
        </v-text-field>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col>
        <v-text-field
          :readonly="disabledView"
          dense
          rounded
          outlined
          v-model="localValue.strTelefono2"
          label="EXT, Telefono 2"
        >
        </v-text-field>
      </v-col>
    </v-row>

    <v-row v-if="!disabledView" no-gutters>
      <v-col>
        <v-btn rounded color="primary" block @click="save()">Guardar</v-btn>
      </v-col>
    </v-row>

    
  </v-row>
  </v-container>
</template>

<script>
import Keyboard from "./Keyboard.vue";
import { POSEncFunctions, POSCliente } from "../controllers/POSController.js";
import { Session, Toast, ErrorWeb, Data } from "../controllers/DataController.js";


export default {
  props: {
    value: {
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tipo: {
    type: Object,
    default: () => ({ valor: 1 })
  },
    // AGREGADAS
    colonias: {
      type: Array,
      default: () => [],
    },
    repartidores: {
      type: Array,
      default: () => [],
    },
    orden: {
      type: Object,
      default: () => ({ intEstatus: 0 }),
    },

    
  },

  components: {
    Keyboard,
    
  },

  data() {
    return {
      dataController: new Data(),
      search: null,
      // AGREGADO
      session: new Session(),
      loading: false,
      config_35_valor:this.$config.opciones.find((c) => c.id == 35).valor,
      config_35_activo:this.$config.opciones.find((c) => c.id == 35).activo,
      keyboardSession: false,
      disabledView: !this.$config.opciones.find((c) => c.id == 35).activo,

      POSEnc: { intEstatus: 0 },

      ordenFunctions: new POSEncFunctions(this.$config.api_backend_route),
      
      config_17:this.$config.opciones.find((c) => c.id == 17).valor,
      telefonoBusqueda: "",
      POSCliente: new POSCliente(),

      clientes: { data: [] },

      items: [],
      localValue: this.value,

      keyboard: {
        visible: false,
        input: null,
      },
      

      venta: this.data,
    };
  },

  methods: {
    showKeyboard(e) {
      if (this.keyboardSession && !this.disabled) {
        this.keyboard.input = e.target;
        this.keyboard.visible = true;
      }
    },
    async cargarTelefonos() {
  if (!this.localValue.strTelefono) {
    this.clientes.data = await this.ordenFunctions.clientes("");
  }
},
async save() {
      this.loading = true;
      try {

        if (this.localValue.intCliente > 0) {
          // if( this.localValue.intCliente > 0 && (data != undefined || data == "")){
          await this.ordenFunctions.editarCliente(
            this.localValue,
            this.session.empresa,
            this.session.usuario,
            this.session.terminal
          );
          console.log("save cliente",this.localValue.intCliente )
          this.$toast.success("Cliente actualizado con exito", new Toast());
        } else {
          console.log("save cliente",this.localValue.intCliente )
          if(this.tipo.valor == 1){
            if(this.localValue.strTelefono== "" || !this.localValue.strTelefono)
              throw "Favor de agregar Telefono";
          }
          if (this.localValue.strTelefono.replace(/\D/g, '').length < 10){
            throw "El telefono debe tener al menos 10 numeros";
          }
          
    
        

          let response = await this.ordenFunctions.saveCliente(
            this.localValue,
            this.session.empresa,
            this.session.usuario,
            this.session.terminal
          );
          this.localValue.intCliente = response.intCliente;
          this.$toast.success("Cliente agregado con exito", new Toast());
        }
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },
async cargarCliente(telefono) {

if(!telefono) return;
console.log(telefono)
let data = await this.ordenFunctions.dataclientes(telefono.strTelefono);
console.log(data);
if(data){
  this.localValue.intCliente = data.intCliente;
  this.localValue.strColonia = data.strColonia;
  this.localValue.strDireccion = data.strDireccion;
  this.localValue.strEntreCalle = data.strEntreCalle;
  this.localValue.strNombre = data.strNombre;
  this.localValue.strNumeroExterior = data.strNumeroExterior;
  this.localValue.strNumeroInterior = data.strNumeroInterior;
  this.localValue.strPoblacion = data.strPoblacion;
  this.localValue.strReferencia = data.strReferencia;
  this.localValue.strTelefono = data.strTelefono;
  this.localValue.strTelefonoLlevar = data.strTelefono;
  this.localValue.strRFC = data.strRFC;
}

},
    
    querySelections (v) {
      this.loading = true
      // Simulated ajax query
      setTimeout(() => {
        this.items = this.clientes.data.filter(e => {
  return (e.strTelefono || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
})
        this.loading = false
      }, 500)
    },

    seleccionarCliente(cliente) {
  console.log(cliente);
  this.buscarCliente.isVisible = false;

  this.localValue.intCliente = cliente.intCliente || 0;
  this.localValue.strTelefono = cliente.strTelefono || "";
  this.localValue.strNombre = cliente.strNombre || "";
  this.localValue.strColonia = cliente.strColonia || "";
  this.localValue.strDireccion = cliente.strDireccion || "";
  this.localValue.strEntreCalle = cliente.strEntreCalle || "";
  this.localValue.strNumeroExterior = cliente.strNumeroExterior || "";
  this.localValue.strNumeroInterior = cliente.strNumeroInterior || "";
  this.localValue.strPoblacion = cliente.strPoblacion || "";
  this.localValue.strReferencia = cliente.strReferencia || "";
  this.localValue.strRFC = cliente.strRFC || "";
},
  },

  async mounted() {
    this.keyboardSession = new Session().keyboard;
    console.log("entra", this.localValue.tipo);
    this.clientes.data = await this.ordenFunctions.clientes(
      this.localValue.strTelefono );
    let tipoventas = await this.dataController.loadTipoVentas();
    console.log(tipoventas);
    console.log(this.venta);
  },

  watch: {
    localValue(newValue) {
      this.$emit("input", newValue);
    },
    search (val) {
      val && this.querySelections(val)
    },
    config_35_activo(val){
    this.disabledView = !val;
  },
    
    value(newValue) {
      this.localValue = newValue;
    },

    async ["localValue.clave"](newVal) {
      
// si la clave se vacía
if (!newVal || newVal === "") {

  // limpiar telefono y datos cliente
  this.localValue.strTelefono = "";
  this.localValue.intCliente = 0;
  this.localValue.strNombre = "";
  this.localValue.strColonia = "";
  this.localValue.strDireccion = "";
  this.localValue.strEntreCalle = "";
  this.localValue.strNumeroExterior = "";
  this.localValue.strNumeroInterior = "";
  this.localValue.strPoblacion = "";
  this.localValue.strReferencia = "";
  this.localValue.strRFC = "";

  // recargar lista de telefonos igual que al iniciar
  this.clientes.data = await this.ordenFunctions.clientes("");
}
},
async ["localValue.strTelefono"](newVal) {


let telefono = typeof newVal === "object"
  ? newVal?.strTelefono
  : newVal;

if (!telefono || telefono.replace(/\D/g, '').length < 10) return;

let data = await this.ordenFunctions.dataclientes(telefono);

if (data) {
  this.localValue.strTelefono = telefono;
  this.localValue.intCliente = data.intCliente || 0;
  this.localValue.strNombre = data.strNombre || "";
  this.localValue.strColonia = data.strColonia || "";
  this.localValue.strDireccion = data.strDireccion || "";
  this.localValue.strEntreCalle = data.strEntreCalle || "";
  this.localValue.strNumeroExterior = data.strNumeroExterior || "";
  this.localValue.strNumeroInterior = data.strNumeroInterior || "";
  this.localValue.strPoblacion = data.strPoblacion || "";
  this.localValue.strReferencia = data.strReferencia || "";
  this.localValue.strRFC = data.strRFC || "";
} else {
    this.localValue.intCliente=0;
    this.localValue.strColonia= "";
    this.localValue.strDireccion= "";
    this.localValue.strEntreCalle= "";
    this.localValue.strNombre= "";
    this.localValue.strNumeroExterior= "";
    this.localValue.strNumeroInterior="";
    this.localValue.strPoblacion= "";
    this.localValue.strReferencia= "";
    //this.localValue.strTelefono= "";
    this.localValue.strNombre= "";
  }



},


// async ["localValue.intCliente"](newValue) {
// //async orden(newValue) {
//   console.log("MOUNTED DE ORDEN: ");
//   console.log(newValue);
// this.POSEnc = newValue || { intEstatus: 0 };

// if (newValue && newValue.intCliente) {

//   // consultar cliente por id
//   const cliente = await this.ordenFunctions.dataclientes(newValue.intCliente);

//   if (cliente) {
//     this.localValue.strTelefono = cliente.strTelefono;
//     this.localValue.strTelefono = cliente.strNombre;

//     // cargar datos completos
//     await this.cargarCliente(cliente.strTelefono);
//   }

// }

// },
  },
};
</script>

<style></style>